class SearchFaq extends HTMLElement {
  constructor() {
    super();
    this.faqs = [];
    this.input = this.querySelector('[data-input]');
    this.reset = this.querySelector('[data-reset]');
    this.categoryDropdown = this.querySelector('[data-categories]');
    this.countElement = this.querySelector('[data-count]');

    this.sections = Array.from(document.querySelectorAll('.faq-section'));
    this.questions = Array.from(document.querySelectorAll('[data-question]'));
    console.log('[SearchFaq] Initialized');
  }

  connectedCallback() {
    console.log('[SearchFaq] Connected');
    this.extractFaqs();
    this.bindInputEvents();
    this.populateCategories();
    this.reset?.addEventListener('click', () => this.clearFilters());
  }

  extractFaqs() {
    const allQuestions = document.querySelectorAll('content-accordion [data-question]');
    this.faqs = Array.from(allQuestions).map((element) => {
      const toggle = element.querySelector('[data-toggle]');
      const heading = toggle?.querySelector('[data-heading]');
      const answer = element.querySelector('[data-content] p');

      if (toggle && heading && answer) {
        return {
          id: toggle.getAttribute('data-toggle'),
          question: heading.innerText.trim(),
          answer: answer.innerText.trim(),
        };
      }
      return null;
    }).filter(Boolean);

    if (this.countElement) {
      this.countElement.textContent = this.faqs.length.toString();
    }

    console.log(`[SearchFaq] FAQs extracted: ${this.faqs.length}`);
  }

  bindInputEvents() {
    if (!this.input) return;

    this.input.addEventListener('input', this.debounce((e) => {
      const value = e.target.value.trim().toLowerCase();
      if (!value) {
        this.clearFilters();
        return;
      }

      this.searchFaqs(value);
    }, 300));
  }

  populateCategories() {
    const categories = new Set(
      this.sections.map(section => section.querySelector('[data-category]')?.textContent?.trim()).filter(Boolean)
    );

    categories.forEach((category) => {
      const option = document.createElement('option');
      option.value = category.toLowerCase();
      option.textContent = category;
      this.categoryDropdown.appendChild(option);
    });

    this.categoryDropdown.addEventListener('change', (e) => {
      const value = e.target.value;
      this.filterByCategory(value);
    });
  }

  filterByCategory(category = '') {
    this.sections.forEach((section) => {
      const cat = section.querySelector('[data-category]')?.textContent?.trim().toLowerCase();
      section.style.display = (!category || cat === category) ? 'flex' : 'none';
    });
  }

  searchFaqs(searchTerm) {
    const matches = this.faqs.filter(faq =>
      faq.question.toLowerCase().includes(searchTerm) ||
      faq.answer.toLowerCase().includes(searchTerm)
    );

    this.questions.forEach((q) => {
      const isMatch = matches.some(f => f.id === q.dataset.question);
      q.style.display = isMatch ? 'flex' : 'none';
    });
  }

  clearFilters() {
    if (this.input) this.input.value = '';
    if (this.categoryDropdown) this.categoryDropdown.selectedIndex = 0;

    this.sections.forEach(section => section.style.display = 'flex');
    this.questions.forEach(q => q.style.display = 'flex');
  }

  debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
}

customElements.define('search-faq', SearchFaq);
